export const RESET_PWD_DONE =
  'Your password has been sent to your registered email address.'
export const INCORRECT_CREDENTIALS =
  'Please enter valid login credentials and try again.'
export const FORGOT_INCORRECT_CREDENTIALS =
  'Please enter valid details and try again.'
export const UNLOCK_LESSON_POD =
  'Are you sure you want to unlock this Lesson pod? Clicking "OK" will erase your work on all other devices.'
export const NOTHING_FOR_REPLAY = 'There is nothing to replay.'
export const SEQUENCE_TYPE = 'Type answer and hit tab to go to the next field'
export const SEQUENCE_SELECT = 'Select answer to go to the next field'
export const NAVIGATION_PAPER =
  'Type or Select answer and hit tab to go to the next field'
export const EXCERCISE_SAVED = 'Exercise saved successfully.'
export const DONE_CONFIRMATION = 'Do you want to mark this activity as done?'
export const RESET_CONFIRMATION =
  'Do you want to clear your work and reset this activity?'
export const NOT_SKIPPED = 'The last item cannot be skipped.'
export const TILE_MATCHED = 'Item already matched with tile!'
export const ERROR_HAPPENED =
  'Your request could not be processed. Please try again or contact your administrator.'
export const RESUME_VIDEO = 'Resuming Video'
export const RECORD_CONFIRMATION = 'Do you want to save this audio?'
export const RECORD_DELETE = 'Do you want to delete this audio?'

export const SMALL_DESKTOP = '18px'
export const MEDIUM_DESKTOP = '20px'
export const LARGE_DESKTOP = '22px'
export const XLARGE_DESKTOP = '50px'
export const HEADING_SIZE = '30px'
export const RESULT_SCREEN_HEADING1 = '35px'
export const SMALL = '16px'
export const MEDIUM = '18px'
export const LARGE = '20px'
export const MAX_QUESTION_HEIGHT = '36%'
export const MIN_QUESTION_HEIGHT = '10%'
export const MIN_CANVAS_HEIGHT = '64%'

// Color

export const GRAY_ICON = '#BDBCBC'
export const PEN = 'stroke'
export const LINE = 'line'
export const RECT = 'rectangle'
export const CIRCLE = 'circle'
export const SELECT = 'select'
export const EXTRA_SMALL_PEN = 1.5
export const SMALL_PEN = 3
export const MEDIUM_PEN = 5
export const LARGE_PEN = 8
export const NONE_PEN = 0
export const TWOTIMES = 250
export const ONETIME = 500
export const HALFTIME = 1000

//Canvas header
export const CHAT_BOT = 'chatBot'
export const PREVIOUS_WORK = 'previousWork'
export const QUESTION = 'question'
export const TEXT_AREA = 'textArea'
export const SKETCH_PAD = 'sketchPad'
export const REPLAY = 'replay'
export const COLOR_PALETTE = 'colorPalette'
export const RECORDING = 'recording'

//Audio playing
export const TUTOR_BOT = 'tutorBot'
export const SEQUENCE_BOT = 'sequenceBot'
export const FEEDBACK_BOT = 'feedbackBot'
export const MATCH_BOT = 'matchBot'
